import React from 'react';
import toast from 'react-hot-toast';
import { grafikService } from '../../services/grafikService';
import {
  parseShiftTime, formatHours, getStatusColor, getStatusLabel,
  toISODate, getMonthDays, getMondayBasedIndex, groupShiftsByDate,
  shortLocationCode
} from '../../utils/grafikHelpers';

const WEEKDAY_HEADERS = ['Pn', 'Wt', 'Sr', 'Cz', 'Pt', 'So', 'Nd'];

/**
 * Widok miesiaca dla pracownika (read-only). Z mozliwoscia akceptacji zmiany.
 * Props: year, month, shifts, onAccepted()
 */
const MyMonthView = ({ year, month, shifts = [], onAccepted }) => {
  const days = getMonthDays(year, month);
  const byDate = groupShiftsByDate(shifts);
  const todayIso = toISODate(new Date());
  const firstOffset = days.length > 0 ? getMondayBasedIndex(days[0]) : 0;
  const totalCells = firstOffset + days.length;
  const rows = Math.ceil(totalCells / 7);

  const handleAccept = async (shift) => {
    try {
      await grafikService.acceptShift(shift.id);
      toast.success('Zmiana zaakceptowana');
      onAccepted && onAccepted();
    } catch (err) {
      toast.error(err.message || 'Blad akceptacji zmiany');
    }
  };

  return (
    <div>
      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '2px', marginBottom: '2px'
      }}>
        {WEEKDAY_HEADERS.map(d => (
          <div key={d} style={{
            padding: '0.4rem', textAlign: 'center', fontWeight: 600,
            fontSize: '0.75rem', color: 'var(--text-secondary)',
            backgroundColor: 'var(--bg)', borderRadius: '4px'
          }}>{d}</div>
        ))}
      </div>

      <div style={{
        display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)',
        gridTemplateRows: `repeat(${rows}, minmax(90px, auto))`, gap: '2px'
      }}>
        {Array.from({ length: firstOffset }).map((_, idx) => (
          <div key={`empty-${idx}`} style={{
            backgroundColor: 'var(--bg)', borderRadius: '4px', opacity: 0.3
          }} />
        ))}

        {days.map(date => {
          const iso = toISODate(date);
          const dayShifts = byDate[iso] || [];
          const isToday = iso === todayIso;
          const dow = getMondayBasedIndex(date);
          const isWeekend = dow >= 5;

          return (
            <div key={iso} style={{
              backgroundColor: isWeekend ? 'var(--bg)' : 'var(--card-bg)',
              border: isToday ? '2px solid var(--info)' : '1px solid var(--border)',
              borderRadius: '4px', padding: '0.4rem', minHeight: '90px',
              display: 'flex', flexDirection: 'column', gap: '0.25rem'
            }}>
              <div style={{
                fontSize: '0.75rem', fontWeight: 600,
                color: isToday ? 'var(--info)' : (isWeekend ? 'var(--text-muted)' : 'var(--text)')
              }}>
                {date.getDate()}
              </div>

              {dayShifts.map(s => {
                const color = getStatusColor(s.status);
                const od = parseShiftTime(s.godzina_od);
                const doG = parseShiftTime(s.godzina_do);
                const locShort = shortLocationCode(s.location_nazwa || s.lokalizacja);
                const isAbsence = ['urlop', 'chorobowe', 'nieobecnosc', 'wolne'].includes(s.status);
                const isAccepted = !!(s.zaakceptowana_przez_pracownika === 1
                  || s.zaakceptowana_przez_pracownika === true
                  || s.zaakceptowana_przez_pracownika === '1');
                const showAcceptBtn = !isAbsence && !isAccepted;

                return (
                  <div key={s.id} style={{
                    backgroundColor: `${color}22`, borderLeft: `3px solid ${color}`,
                    borderRadius: '3px', padding: '0.3rem 0.4rem', fontSize: '0.7rem'
                  }}>
                    {isAbsence ? (
                      <div style={{ color, fontWeight: 600, textTransform: 'uppercase' }}>
                        {getStatusLabel(s.status)}
                      </div>
                    ) : (
                      <>
                        <div style={{ fontWeight: 600 }}>
                          {od}-{doG}{locShort ? ` · ${locShort}` : ''}
                        </div>
                        <div style={{ color: 'var(--text-muted)', fontSize: '0.65rem' }}>
                          {getStatusLabel(s.status)}
                          {s.godziny_planowane !== undefined && ` · ${formatHours(s.godziny_planowane)}`}
                        </div>
                      </>
                    )}
                    {showAcceptBtn && (
                      <button onClick={() => handleAccept(s)}
                        style={{
                          marginTop: '0.2rem', padding: '4px 10px',
                          backgroundColor: 'var(--success)', color: '#fff', border: 'none',
                          cursor: 'pointer', fontSize: '11px', fontWeight: 600
                        }}>
                        Akceptuj
                      </button>
                    )}
                    {isAccepted && !isAbsence && (
                      <div style={{
                        marginTop: '0.2rem', fontSize: '0.65rem',
                        color: 'var(--success)', fontWeight: 600
                      }}>
                        <i className="fas fa-check-circle" style={{ marginRight: '0.2rem' }} />
                        Zaakceptowana
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MyMonthView;
